var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineChartEmptyData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 140,
    viewBox: "0 0 181 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.673 39.1159H60.1048C58.0291 39.1159 56.0384 39.9377 54.5706 41.4006C53.1029 42.8634 52.2783 44.8475 52.2783 46.9163V132.2C52.2783 134.268 52.2783 140 52.2783 140C52.2783 140 58.0291 140 60.1048 140H119.307H143.122H145.673C147.749 140 153.499 140 153.499 140C153.499 140 153.499 134.268 153.499 132.2V46.9163C153.499 44.8475 152.675 42.8634 151.207 41.4006C149.739 39.9377 147.749 39.1159 145.673 39.1159Z",
    fill: "#BFCCEF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.9414,
    y: 80.3983,
    width: 14.9312,
    height: 12.4012,
    fill: "#F7F7F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9414,
    y: 99.0018,
    width: 14.9312,
    height: 12.4012,
    fill: "#F7F7F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9414,
    y: 117.602,
    width: 14.9312,
    height: 12.4012,
    fill: "#F7F7F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 84.0918,
    y: 80.3983,
    width: 14.9312,
    height: 12.4012,
    fill: "#F7F7F7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84.0918,
    y: 99.0018,
    width: 14.9312,
    height: 12.4012,
    fill: "#F7F7F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84.0918,
    y: 117.602,
    width: 14.9312,
    height: 12.4012,
    fill: "#F7F7F7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 105.252,
    y: 80.3983,
    width: 14.9312,
    height: 12.4012,
    fill: "#F7F7F7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 105.252,
    y: 99.0018,
    width: 14.9312,
    height: 12.4012,
    fill: "#F7F7F7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 105.252,
    y: 117.602,
    width: 14.9312,
    height: 12.4012,
    fill: "#F7F7F7"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 126.403,
    y: 80.3983,
    width: 14.9312,
    height: 12.4012,
    fill: "#F7F7F7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 126.403,
    y: 99.0018,
    width: 14.9312,
    height: 12.4012,
    fill: "#F7F7F7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 126.403,
    y: 117.602,
    width: 14.9312,
    height: 12.4012,
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0505 39.1161H146.034C148.014 39.1161 153.5 39.1161 153.5 39.1161C153.5 39.1161 153.5 44.5835 153.5 46.5569V70.6773C153.5 70.7529 153.469 70.8255 153.416 70.8789C153.362 70.9324 153.289 70.9625 153.213 70.9625H52.5646C52.4887 70.9625 52.416 70.9324 52.3623 70.8789C52.3086 70.8255 52.2785 70.7529 52.2785 70.6773V47.8466C52.2718 46.6972 52.4943 45.5579 52.933 44.4949C53.3716 43.4319 54.8338 41.6541 54.8338 41.6541C54.8338 41.6541 56.6196 40.1994 57.6868 39.7637C58.7539 39.328 59.8973 39.1079 61.0505 39.1161Z",
    fill: "#8496C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.034 57.0592C117.034 57.1786 110.079 57.2661 101.506 57.2661C92.9327 57.2661 85.9648 57.1786 85.9648 57.0592C85.9648 56.9397 92.9203 56.8362 101.518 56.8362C110.116 56.8362 117.034 56.9477 117.034 57.0592Z",
    fill: "#525B8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.995 29.2313H117.784C116.025 29.2313 114.599 30.6526 114.599 32.406V48.8376C114.599 50.591 116.025 52.0123 117.784 52.0123H117.995C119.755 52.0123 121.181 50.591 121.181 48.8376V32.406C121.181 30.6526 119.755 29.2313 117.995 29.2313Z",
    fill: "#DFE1E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.099 29.2313H86.8875C85.1283 29.2313 83.7021 30.6526 83.7021 32.406V48.8376C83.7021 50.591 85.1283 52.0123 86.8875 52.0123H87.099C88.8582 52.0123 90.2843 50.591 90.2843 48.8376V32.406C90.2843 30.6526 88.8582 29.2313 87.099 29.2313Z",
    fill: "#DFE1E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M79.9295 38.9935C80.3444 43.0326 79.9566 47.1136 78.7884 51.0032C77.6201 54.8928 75.6943 58.5149 73.121 61.6624C70.5476 64.81 67.3772 67.4212 63.7908 69.347C60.2045 71.2729 56.2726 72.4754 52.2197 72.8861L53.464 55.9336L68.8805 39.2292L79.9295 38.9935Z",
    fill: "#1C1C1F"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0033 66.5443C68.5423 62.6398 77.9634 46.9196 74.0458 31.4324C70.1283 15.9451 54.3556 6.55535 38.8166 10.4599C23.2775 14.3644 13.8565 30.0845 17.774 45.5718C21.6916 61.0591 37.4643 70.4488 53.0033 66.5443Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6874 70.9099C39.5246 70.906 33.4928 69.1362 28.3109 65.8114C23.1289 62.4865 19.0154 57.7469 16.4604 52.1573C13.9055 46.5677 13.0168 40.3638 13.9004 34.2849C14.784 28.206 17.4026 22.5085 21.444 17.8713C25.4855 13.2341 30.7795 9.85285 36.6951 8.13038C42.6106 6.4079 48.8984 6.41689 54.809 8.15626C60.7196 9.89564 66.0038 13.292 70.0319 17.9408C74.06 22.5895 76.6621 28.2944 77.5282 34.3758C78.7149 42.7854 76.5076 51.3209 71.3903 58.1112C66.273 64.9014 58.6632 69.3925 50.229 70.5998C48.7241 70.8067 47.2066 70.9103 45.6874 70.9099ZM45.7621 13.0829C44.5132 13.0815 43.2658 13.1685 42.0293 13.3433C36.9645 14.068 32.2288 16.2728 28.4208 19.679C24.6128 23.0852 21.9032 27.54 20.6345 32.4805C19.3659 37.421 19.595 42.6254 21.293 47.4361C22.991 52.2468 26.0817 56.448 30.1745 59.5086C34.2673 62.5693 39.1785 64.3521 44.2875 64.6319C49.3966 64.9116 54.4742 63.6757 58.8787 61.0802C63.2832 58.4848 66.817 54.6464 69.0335 50.05C71.2501 45.4537 72.0498 40.3056 71.3318 35.2563C70.4579 29.1134 67.3917 23.4901 62.6954 19.4176C57.999 15.345 51.9872 13.096 45.7621 13.0829Z",
    fill: "#9CA9DA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8903 -0.00013311L58.2393 4.23737L75.2882 14.8325L77.9392 10.595L60.8903 -0.00013311Z",
    fill: "#9CA9DA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4388 7.06203L5.5 22.8699L9.25721 26.1608L23.196 10.353L19.4388 7.06203Z",
    fill: "#9CA9DA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.038 31.3351L39.1162 46.2166",
    stroke: "#6C6D75",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1163 31.3351L54.0381 46.2166",
    stroke: "#6C6D75",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartEmptyData);
export default __webpack_public_path__ + "static/media/LineChartEmptyData.6b76c7b5.svg";
export { ForwardRef as ReactComponent };